import * as p from './statePaths';
import * as r from 'ramda';

export function ingredientGroups(state) {
    return r.path(p.ingredientGroups, state) || [];
}

export function modes(state) {
    return r.path(p.modes, state) || [];
}

export function selectedIngredients(state) {
    return allIngredients(state).filter(
        (ingredient) => (ingredient.count || 0) > 0
    );
}

export function allIngredients(state) {
    return (r.path(p.ingredientGroups, state) || []).reduce(
        (all, group) => all.concat(group.ingredients),
        []
    );
}

export function localeCode(state) {
    return r.path(p.localeCode, state);
}

export function currencyCode(state) {
    return r.path(p.currencyCode, state);
}

export function texts(state) {
    return r.path(p.texts, state);
}

export function basePrice(state) {
    return r.path(p.basePrice, state);
}

export function totalPrice(state) {
    return selectedIngredients(state).reduce((total, ingredient) => {
        return total + (ingredient.price || 0) * (ingredient.count || 0);
    }, basePrice(state));
}

export function submitUrl(state) {
    return r.path(p.submitUrl, state);
}
